import { targetsWithoutAll } from "@/shared/utils/constant";
import { useState } from "react";
import { isGreaterThanZero } from "@/shared/utils/helpers";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Category, Product } from "@/shared/utils/interfaces";
import InputColor from "../Input/InputColor";
import TargetOverrideList from "../TargetOverrides/TargetOverrideList";

interface ColorPerTargetProps {
  data: Product | Category;
}

const ColorPerTarget = ({ data }: ColorPerTargetProps) => {
  const { t } = useTranslation();
  const formContext = useFormContext();

  const { text_color_per_target, back_ground_color_per_target } = data ?? {};
  const { control, errors } = formContext;
  const defaultTargetIds = Object.keys(back_ground_color_per_target ?? {});

  const [localTargets, setLocalTargets] = useState(
    isGreaterThanZero(defaultTargetIds)
      ? targetsWithoutAll
          .filter((t) => defaultTargetIds.includes(`${t.value}`))
          .map((t) => ({
            ...t,
            text_color_per_target: text_color_per_target?.[t.value] || "",
            back_ground_color_per_target:
              back_ground_color_per_target?.[t.value] || "",
          }))
      : []
  );

  return (
    <TargetOverrideList
      icon="highlighter"
      title={t("menu.colorPerTarget")}
      description={t("targetOverrides.colorHint")}
      targets={localTargets}
      onAdd={(target) =>
        setLocalTargets((prev) => [
          ...prev,
          {
            ...target,
            text_color_per_target: "",
            back_ground_color_per_target: "",
          },
        ])
      }
      onRemove={(target) =>
        setLocalTargets((prev) => prev.filter((t) => t.value !== target.value))
      }
      renderControl={(target) => (
        <div className="flex flex-wrap gap-6">
          <Controller
            name={`back_ground_color_per_target.%${target.value}`}
            defaultValue={target?.back_ground_color_per_target}
            control={control}
            render={({ onChange, value, name }) => (
              <div>
                <InputColor
                  showLabel
                  hideTextfield
                  name={name}
                  errors={errors}
                  label={t("backGroundColor")}
                  onChange={(value) => onChange(value)}
                  value={value}
                />
              </div>
            )}
          />
          <Controller
            name={`text_color_per_target.%${target.value}`}
            defaultValue={target?.text_color_per_target}
            control={control}
            render={({ onChange, value, name }) => (
              <div>
                <InputColor
                  showLabel
                  hideTextfield
                  name={name}
                  errors={errors}
                  label={t("textColor")}
                  onChange={(value) => onChange(value)}
                  value={value}
                />
              </div>
            )}
          />
        </div>
      )}
    />
  );
};

export default ColorPerTarget;
